import Dexie, { Table } from "dexie";
import { LocalSession } from "../types";

export interface SettingRecord {
  key: string;
  value: unknown;
  createdAt: string;
  updatedAt: string;
  tags?: string[];
  meta?: Record<string, unknown>;
}

export interface AchievementRecord {
  id: string;
  createdAt: string;
  updatedAt: string;
  title: string;
  body: string;
  tags?: string[];
  meta?: Record<string, unknown>;
}

export interface BackupRecord {
  id: string;
  createdAt: string;
  updatedAt: string;
  payload: unknown;
  tags?: string[];
  meta?: Record<string, unknown>;
}

class AfterglowDB extends Dexie {
  settings!: Table<SettingRecord, string>;
  sessions!: Table<LocalSession, string>;
  achievements!: Table<AchievementRecord, string>;
  backups!: Table<BackupRecord, string>;

  constructor() {
    super("afterglow-atlas.v1.db");
    this.version(1).stores({
      settings: "key, updatedAt",
      sessions: "id, roomId, deviceHash, createdAt, updatedAt, *tags",
      achievements: "id, createdAt, updatedAt, *tags",
      backups: "id, createdAt, updatedAt, *tags"
    });
  }
}

export const db = new AfterglowDB();

export async function persistStorageIfPossible() {
  if (navigator.storage?.persist) {
    try {
      return await navigator.storage.persist();
    } catch {
      return false;
    }
  }
  return false;
}

export async function exportLocalArchive() {
  const [settings, sessions, achievements, backups] = await Promise.all([
    db.settings.toArray(),
    db.sessions.toArray(),
    db.achievements.toArray(),
    db.backups.toArray()
  ]);
  return {
    appSlug: "afterglow-atlas",
    exportedAt: new Date().toISOString(),
    settings,
    sessions,
    achievements,
    backups
  };
}
